import React from "react";
import Box from "@mui/material/Box";
import CommentsList from "./CommentsList";
import LeaveCommentForm from "./LeaveCommentForm";

const CommentsSection = ({
  comment,
  setComment,
  handleSubmitComment,
  feedbackLoading,
  comments,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", marginTop: { xs: "30px", sm: "40px", md: "60px" } }}>
      <Box
        sx={{
          color: "#0C141B",
          fontFamily: "Inter",
          fontSize: { xs: "22px", sm: "26px", md: "34px" },
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "normal",
          marginBottom: { xs: "24px", sm: "36px", md: "60px" },
        }}
      >
        Comments & Discussion
      </Box>

      <CommentsList comments={comments} />

      <Box
        sx={{
          borderBottom: "1px solid #E5E9EC",
          marginTop: comments.length === 0 ? "20px" : "0",
          marginBottom: { xs: "24px", md: "40px" },
        }}
      />

      <LeaveCommentForm
        comment={comment}
        setComment={setComment}
        handleSubmitComment={handleSubmitComment}
        feedbackLoading={feedbackLoading}
      />
    </Box>
  );
};

export default CommentsSection;
